module.exports = __webpack_public_path__ + "static/media/sort-asc-arrow.15973a3e.svg";